import React from "react"
import { Layout } from "antd"
import { Outlet } from "react-router-dom"
import styles from "./Index.module.css"

export const ProBookingsLayout = () => {
  return (
    <Layout className={styles.layout}>
      <Outlet />
    </Layout>
  )
}
